import React from "react";

interface YearIconProps {
  width?: string;
  height?: string;
  fillColor?: string;
}

const YearIcon: React.FC<YearIconProps> = ({
  width = "24px",
  height = "24px",
  fillColor = "#00132E",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 329.4 311.72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M243.3,66.9c-5.52,0-10-4.48-10-10V10c0-5.52,4.48-10,10-10s10,4.48,10,10v46.9c0,5.52-4.48,10-10,10Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M77.42,66.9c-5.52,0-10-4.48-10-10V10c0-5.52,4.48-10,10-10s10,4.48,10,10v46.9c0,5.52-4.48,10-10,10Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M319.4,121.49H10c-5.52,0-10-4.48-10-10s4.48-10,10-10h309.4c5.52,0,10,4.48,10,10s-4.48,10-10,10Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M295.49,311.72H33.91c-18.7,0-33.91-15.21-33.91-33.91V59.31C0,40.61,15.21,25.39,33.91,25.39h261.57c18.7,0,33.91,15.21,33.91,33.91v218.5c0,18.7-15.21,33.91-33.91,33.91ZM33.91,45.39c-7.67,0-13.91,6.24-13.91,13.91v218.5c0,7.67,6.24,13.91,13.91,13.91h261.57c7.67,0,13.91-6.24,13.91-13.91V59.31c0-7.67-6.24-13.91-13.91-13.91H33.91Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M87.88,149.38h-20.92c-1.92,0-3.69,1.01-4.66,2.66l-10.36,17.59c-1,1.69-1,3.8,0,5.49l10.36,17.59c.97,1.65,2.75,2.66,4.66,2.66h20.92c1.92,0,3.69-1.01,4.66-2.66l10.36-17.59c1-1.69,1-3.8,0-5.49l-10.36-17.59c-.97-1.65-2.75-2.66-4.66-2.66Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M87.88,219.91h-20.92c-1.92,0-3.69,1.01-4.66,2.66l-10.36,17.59c-1,1.69-1,3.8,0,5.49l10.36,17.59c.97,1.65,2.75,2.66,4.66,2.66h20.92c1.92,0,3.69-1.01,4.66-2.66l10.36-17.59c1-1.69,1-3.8,0-5.49l-10.36-17.59c-.97-1.65-2.75-2.66-4.66-2.66Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M253.76,149.38h-20.92c-1.92,0-3.69,1.01-4.66,2.66l-10.36,17.59c-1,1.69-1,3.8,0,5.49l10.36,17.59c.97,1.65,2.75,2.66,4.66,2.66h20.92c1.92,0,3.69-1.01,4.66-2.66l10.36-17.59c1-1.69,1-3.8,0-5.49l-10.36-17.59c-.97-1.65-2.75-2.66-4.66-2.66Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M253.76,219.91h-20.92c-1.92,0-3.69,1.01-4.66,2.66l-10.36,17.59c-1,1.69-1,3.8,0,5.49l10.36,17.59c.97,1.65,2.75,2.66,4.66,2.66h20.92c1.92,0,3.69-1.01,4.66-2.66l10.36-17.59c1-1.69,1-3.8,0-5.49l-10.36-17.59c-.97-1.65-2.75-2.66-4.66-2.66Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M173,149.38h-20.92c-1.92,0-3.69,1.01-4.66,2.66l-10.36,17.59c-1,1.69-1,3.8,0,5.49l10.36,17.59c.97,1.65,2.75,2.66,4.66,2.66h20.92c1.92,0,3.69-1.01,4.66-2.66l10.36-17.59c1-1.69,1-3.8,0-5.49l-10.36-17.59c-.97-1.65-2.75-2.66-4.66-2.66Z"
      style={{ fill: fillColor }}
    />
    <path
      d="M173,219.91h-20.92c-1.92,0-3.69,1.01-4.66,2.66l-10.36,17.59c-1,1.69-1,3.8,0,5.49l10.36,17.59c.97,1.65,2.75,2.66,4.66,2.66h20.92c1.92,0,3.69-1.01,4.66-2.66l10.36-17.59c1-1.69,1-3.8,0-5.49l-10.36-17.59c-.97-1.65-2.75-2.66-4.66-2.66Z"
      style={{ fill: fillColor }}
    />
  </svg>
);

export default YearIcon;
